<template>
	<div class="b-productCard" itemscope itemtype="http://schema.org/Product" :id="product.areaId">
		<a :href="product.detailPageUrl" class="b-productCard__top">
			<div class="b-productCard__front">
				<picture class="b-productCard__imgWrap" :class="{'b-productCard__imgWrap_none': product.stock.enable && product.stock.count === 0 && isViewStock}">
					<source v-if="product.picture.hasOwnProperty('webp')" :data-srcset="product.picture.webp"
					        type="image/webp">
					<img class="b-productCard__img" :src="emptyImg" :data-src="product.picture.src" :alt="product.previewPictureAlt"/>
				</picture>
				<div class="b-label b-label_small"
				     v-for="bullet in product.bullets" :key="bullet.ID"
				     :style="bullet.PICTURE ? 'background-image:url(' + bullet.PICTURE.SRC + ')' : ''"
				     :class="bullet.CLASS ? bullet.CLASS : ''"
				>
					<span v-if="!bullet.PICTURE" v-html="bullet.NAME"></span>
				</div>
			</div>

			<div class="b-productCard__descr" v-if="product.previewText">
				<div class="b-productCard__descrInside">
					<div class="b-productCard__descrTitle"
					     v-html="loc.CITRUS_VUE_PRODUCT_ITEM_DESCR_TITLE"></div>
					<div class="b-productCard__descrContent customScroll">
						<div v-html="product.previewText"></div>
					</div>
				</div>
			</div>
		</a>
		<div class="b-productCard__bottom">
			<div class="b-productCard__main">
				<div class="b-productCard__stock">
					<span v-if="product.stock && product.stock.enable && isViewStock" v-html="loc.CITRUS_VUE_PRODUCT_ITEM_IN_STOCK.replace('#COUNT#', product.stock.count)"></span>
					<span v-else-if="isViewStock">В наличии: много</span>
				</div>
				<div class="b-productCard__title" itemprop="name" v-html="product.name"></div>
			</div>
			<citrus-product-basket-button-with-quantity
				:metric-goal="metricGoal"
				:storage-type="storage"
				:product-id="product.id"
				:product-name="product.name"
				:detail-url="product.detailPageUrl"
				:price="product.price"
				:measure="product.measure"
				:basket-url="basketUrl"
				:button-class="buttonClass"
				:quantity-class="quantityClass"
				:price-class="priceClass"
				:show-price="true"
				:stock="product.stock"
				class="b-productCard__content"
			></citrus-product-basket-button-with-quantity>
		</div>

	</div>
</template>
<script>
import {Vue} from "ui.vue";
import {store} from "citrus.vuex.store";

export default {
	name: "ProductItem",
	props: {
		product: {
			areaId: "",
			id: {
				type: String,
				default: ""
			},
			name: {
				type: String,
				default: ""
			},
			detailPageUrl: {
				type: String,
				default: ""
			},
			picture: {
				type: Object,
				default: function () {
					return {
						src: "",
						width: 0,
						height: 0,
					}
				}
			},
			previewText: {
				type: String,
				default: ""
			},
			price: {
				price: {
					type: Number,
					default: 0
				},
				full: {
					type: Number,
					default: 0
				},
				in_basket: {
					type: Boolean,
					default: false
				},
			},
			weight: {
				type: Number,
				default: 0
			},
			measure: {
				type: Object,
				default: function () {
					return {
						id: 0,
						name: "",
						value: "",
						ratio: "",
					}
				}
			},
			nutrition: {
				type: Object,
				default: function () {
					return {
						proteins: 0,
						fats: 0,
						carbohydrates: 0,
						calories: 0,
					};
				}
			},
			bullets: {
				type: Array,
				default: []
			}
		},
		buttonClass: {
			type: String,
			default: 'b-basketBtn_productCard'
		},
		quantityClass: {
			type: String,
			default: 'b-counter_productCard'
		},
		priceClass: {
			type: String,
			default: 'b-price_productCard'
		},
		emptyImg: {
			type: String,
			default: '/local/templates/redesign/app/assets/dist/img/no_img.webp'
		},
		metricGoal: {
			type: [Boolean, String],
			default: false
		}
	},

	/**
	 * Подключение хранилища данных
	 */
	store,

	data: function () {
		return {
			storage: 'vuex',
			loading: false,
		};
	},
	computed: {
		loc() {
			return Vue.getFilteredPhrases("CITRUS_VUE_PRODUCT_ITEM_");
		},
		hasNutrition() {
			let hasNutrition = false;
			Object.keys(this.product.nutrition).forEach(code => {
				let value = parseFloat(this.product.nutrition[code]);
				if (value > 0) {
					hasNutrition = true;
				}
			});

			return hasNutrition;
		},
		isViewStock() {
			return this.$store.getters['basket/isViewStock'];
		}
	}
}
</script>